import { action, makeObservable, observable, runInAction } from 'mobx';
import { ICompositeProductApi } from '@canvas-logic/clp-sdk';

import { createAttributeValue, hasAttributeValue } from '@canvas-logic/clp-domain';

import React from 'react';
import { IUICfgAttributeDecimal, IUICfgAttributeInteger } from '@canvas-logic/clp-api-types';
import { AttributeCfgUIElementStateBase } from './AttributeCfgUIElementStateBase';
import { DecimalAttributeCfgUIElement } from '@/UiBuilder/elements/DecimalAttributeCfgUIElement/DecimalAttributeCfgUIElement';

let id = 0;

export class DecimalAttributeCfgUIElementState extends AttributeCfgUIElementStateBase<IUICfgAttributeDecimal> {
  public id = 'decimal-view-state-' + ++id;

  value: number | null = null;
  availableValues: number[] = [];
  loading = false;

  constructor(public readonly api: ICompositeProductApi, element: IUICfgAttributeDecimal) {
    super(api, element);
    // this.visible = this.api.isAvailable(this.componentKey);
    this.updateCurrent();
    if (this.value) {
      this.availableValues = [this.value];
    }

    makeObservable(this, {
      loading: observable,
      availableValues: observable,
      value: observable,
      update: action.bound,
      loadAvailableValues: action.bound,
      setValue: action.bound,
    });

    this.update().then(() => this.loadAvailableValues());
  }

  async update() {
    super.update();
    if (this.visible) {
      this.loading = true;
      this.loadAvailableValues();
      runInAction(() => {
        this.loading = false;

        this.updateCurrent();
      });
    }
  }

  async setValue(newValue: number) {
    const attributeValue = createAttributeValue(newValue);
    await this.api.setAttributeValue(this.componentKey, this.attributeKey, attributeValue);
    await this.update();
    this.handleUpdate();
  }

  private handleUpdate() {
    this.notify({
      event: 'updateDependentAttributes',
      attributes: [],
      target: this,
    });
  }

  private updateCurrent() {
    this.value = this.api.getAttributeValue(this.componentKey, this.attributeKey)?.value;
  }

  async loadAvailableValues() {
    const values = await this.api.loadCompatibleAttributeValues(this.componentKey, this.attributeKey);

    runInAction(() => {
      this.availableValues = [];
      for (const attributeValue of values) {
        if (hasAttributeValue(attributeValue)) {
          if (typeof attributeValue.value !== 'undefined') {
            this.availableValues.push(attributeValue.value as number);
          }
        }
      }
    });
  }

  render(): React.ReactElement {
    return <DecimalAttributeCfgUIElement key={this.id} state={this} textData={this.textData} />;
  }
}
